import React, { useState, useEffect } from 'react';
import type { InfoCardMode } from '@arkturian/wave-engine/core/EngineRuntime';
import { EngineRuntime } from '@arkturian/wave-engine/core/EngineRuntime';
import InfoCardTexture from './InfoCardTexture';
import InfoCardCSS3D from './InfoCardCSS3D';
import InfoCardScreen from './InfoCardScreen';

const runtime = EngineRuntime.getInstance();

// ─── Router: picks the active mode ──────────────────────────────────────────

const ParticleInfoCard: React.FC = () => {
    const [mode, setMode] = useState<InfoCardMode>(runtime.infoCardMode);

    useEffect(() => { runtime.infoCardMode = mode; }, [mode]);

    // Listen for mode switches from DOM overlay
    useEffect(() => {
        const handler = (e: Event) => setMode((e as CustomEvent).detail);
        window.addEventListener('infocard-mode', handler);
        return () => window.removeEventListener('infocard-mode', handler);
    }, []);

    return (
        <>
            {mode === 'texture' && <InfoCardTexture />}
            {mode === 'css3d' && <InfoCardCSS3D />}
            {mode === 'screen' && <InfoCardScreen />}
        </>
    );
};

export default ParticleInfoCard;
